/* eslint-disable tailwindcss/no-arbitrary-value */
'use client';

import { BaseAttribute } from '../../types/attributes';
import { VerticalType } from '../../types/cmsTypes';
import { useCmsClientContext } from '../../utils/cmsPageContext';
import { getQuickFacts, getTIUniqueSellingPoint } from '../../utils/helpers';
import { BrandId } from '../../utils/override';
import { getClientTranslations } from '../../utils/translations/getClientTranslations';
import { CollapsibleSection } from '../CollapsibleSection/CollapsibleSection';
import MoneyHeroMarkIcon from '../icons/MoneyHeroMarkIcon';
import MoneyMaxMarkIcon from '../icons/MoneyMaxMarkIcon';
import SingSaverMarkIcon from '../icons/SingsaverMark';
import { TRANSLATIONS } from './i18n';
import { renderListProsCons } from './prosConsRender';
import { ProductCardProps } from './types';

export type SectionTakeProps = {
  isVisible: boolean;
  productAttributes: BaseAttribute[];
  toggleVisibility: () => void;
  vertical?: VerticalType;
  productCardProps?: ProductCardProps;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const takeIcon: Record<BrandId, any> = {
  money101: MoneyMaxMarkIcon,
  moneymax: MoneyMaxMarkIcon,
  moneyhero: MoneyHeroMarkIcon,
  singsaver: SingSaverMarkIcon,
};

const SectionTake: React.FC<SectionTakeProps> = ({
  isVisible,
  productAttributes,
  toggleVisibility,
  vertical,
  productCardProps,
}) => {
  const context = useCmsClientContext();
  const staticText = getClientTranslations(TRANSLATIONS, context);

  const IconComponent = takeIcon[context.brand];

  const quickFacts = getQuickFacts(productAttributes)?.quickFacts;
  const thingsConsider = getQuickFacts(productAttributes)?.thingsConsider;

  const product = productCardProps?.product;
  const tiUniqueSellingPoint = getTIUniqueSellingPoint(
    product?.attributes,
  )?.uniqueSellingPoint;

  return (
    <CollapsibleSection
      id={`section-take-${product?.uid ?? 'default'}`}
      isOpen={isVisible}
      onToggle={toggleVisibility}
      iconClassName="overflow-visible size-[18px] md:size-[22px] md:mb-0 md:mr-2"
      content={
        <div className="p-3">
          <div className="grid grid-cols-1 gap-spacing/gap/soft-12px font-medium text-sm lg:text-base">
            {vertical !== 'TRAVEL_INSURANCE' && (
              <div className="flex flex-col gap-1">
                {renderListProsCons({
                  items: quickFacts?.pros || [],
                  type: 'pros',
                })}

                {renderListProsCons({
                  items: thingsConsider?.pros || [],
                  type: 'pros',
                })}

                {renderListProsCons({
                  items: quickFacts?.cons || [],
                  type: 'cons',
                })}

                {renderListProsCons({
                  items: thingsConsider?.cons || [],
                  type: 'cons',
                })}
              </div>
            )}
            {vertical === 'TRAVEL_INSURANCE' && (
              <div>
                {renderListProsCons({
                  items: tiUniqueSellingPoint?.pros || [],
                  type: 'usp_labels',
                })}
              </div>
            )}
          </div>
        </div>
      }
    >
      <IconComponent className="size-[18px] md:size-[22px]" />{' '}
      <span className="mhg-alpha-bullet-2 lg:mhg-alpha-bullet-1">
        {staticText.brand_take}
      </span>
    </CollapsibleSection>
  );
};

export default SectionTake;
